import { VideosContext } from "@shapeable/ui";
import { useContext } from "react";

export const useVideos = () => (useContext(VideosContext) || []).filter(video => video?.type?.slug !== 'podcast');